<template>
  <div class="demoAccountManagement-container">
    <div class="title">
      <div>{{ $t('tabmenu.name72') }}</div>
      <el-button type="primary" @click="addListData">{{ $t('operate.name11') }}</el-button>
      <el-button type="primary" style="margin-left: 15px" @click="saveListData" :loading="loading1">{{ $t('screen.name168') }}</el-button>
    </div>
    <div class="list">
      <div class="item-list" v-for="(item, index) in listData1" :key="index">
        <div class="item-content1">
          <div class="item-label">{{ $t('manage.name109') }}</div>
          <el-input v-model="item.customerServiceType" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div class="item-content2">
          <div class="item-label">{{ $t('manage.name110') }}</div>
          <el-input v-model="item.content" :placeholder="$t('public.name5')"></el-input>
        </div>
        <div @click="delAccount(item,index)"><i class="el-icon-circle-close"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mcsEdit, mcsQueryList, mcsDelete } from '@/api/user.js'
export default {
  data() {
    return {
      loading1: false,
      listData1: []
    }
  },
  created() {},
  mounted() {
    this.getMcsQueryList()
  },
  methods: {
    getMcsQueryList() {
      mcsQueryList().then(res => {
        if (res.code === 200) {
          this.listData1 = res.data
          if (this.listData1.length === 0) {
            this.addListData()
          }
        }
      }).catch(res => {
      })
    },
    addListData() {
      const obj = {
        customerServiceType: '',
        content: ''
      }
      this.listData1.push(obj)
    },
    saveListData() {
      var postData = this.listData1
      this.loading1 = true
      mcsEdit(postData).then(res => {
        if (res.code === 200) {
          this.getMcsQueryList()
        }
        this.loading1 = false
      }).catch(res => {
        this.loading1 = false
      })
    },
    delAccount(item, index) {
      if (item.id) {
        this.$confirm(this.$t('screen.name14'), this.$t('public.name23'), {
          confirmButtonText: this.$t('public.name25'),
          cancelButtonText: this.$t('public.name14'),
          type: 'warning'
        })
          .then(() => {
            const formData = {
              id: item.id
            }
            mcsDelete(formData)
              .then((res) => {
                if (res.code === 200) {
                  this.$message({
                    type: 'success',
                    message: this.$t('public.name30')
                  })
                  this.getMcsQueryList()
                }
              })
              .catch((res) => {})
          })
          .catch(() => {})
      } else {
        this.listData1.splice(index, 1)
      }
    }
  }
}
</script>
<style lang="scss">
.avatar-uploader {
  margin-right: 30px;
  margin-left: 20px;
  .el-upload {
    width: 100px;
    height: 100px;
  }
  .el-icon-plus {
    font-size: 30px;
  }
}
</style>
<style lang="scss" scoped>
.demoAccountManagement-container {
  display: flex;
  flex-direction: column;
  .marin-top40 {
    margin-top: 40px;
  }
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    div {
      font-size: 18px;
      margin-right: 15px;
    }
  }
  .list {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    .item-list {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      .avatar-uploader {
        width: 100px;
        height: 100px;
        .el-upload {
          width: 100px;
          height: 100px;
        }
        .el-icon-plus {
          font-size: 30px;
        }
        .avatar2{
          width: 100px;
          height: 100px;
        }
      }
      .item-content1 {
        width: 30%;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item-label {
          width: 120px;
          margin-left: 20px;
          text-align: right;
        }
      }
      .item-content2 {
        width: 70%;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item-label {
          width: 120px;
          margin-left: 20px;
          text-align: right;
        }
      }
      .el-icon-circle-close {
        font-size: 26px;
        font-weight: 800;
        margin-left: 20px;
      }
    }
  }
}
</style>
